import React from 'react';

import { COMPANY_NAME } from '../../../constants';

const CompanyName = (): JSX.Element => <span className="summary-hero">{COMPANY_NAME}</span>;

export default CompanyName;
